/* * 本页面为冷柜新增和冷柜修改界面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
    <div ref="pageView" class="page-view container-view">
        <!-- title -->
        <section class="title-section fixed-view">
            <e6-title>
                {{ pageTitle }}
                <template slot="breadcrumb">
                    <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
                </template>
            </e6-title>
        </section>
        <!-- title end -->
        <!-- content -->
        <section
                class="content-section"
                :style="{ height: resizeViewHeight + 'px' }"
        >
            <div class="form-wrapper">
                <e6-form-extend
                        class="e6-from--column-2"
                        ref="formExtend"
                        :formExtend="formExtend"
                        :inline="true"
                        label-width="200px"
                        :submitLoadingState="loadingState"
                        @submitForm="handleSubmitForm"
                        @resetForm="handleResetForm"
                >
                    <template slot-scope="slotForms">
                        <el-form-item
                                label="冷柜名称"
                                prop="forms.freezerName"
                                :rules="[
                {
                  required: true,
                  message: '请输入冷柜名称',
                  trigger: 'blur'
                },
                { validator: CheckRemarkLength, trigger: 'blur' }
              ]"
                        >
                            <el-input
                                    v-model="slotForms.forms.freezerName"
                                    placeholder="冷柜名称"
                                    clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                                prop="forms.comparyId"
                                label="所属企业"
                                :rules="[
                {
                  required: true,
                  message: '请选择所属企业',
                  trigger: 'change'
                }
              ]"
                        >
                            <el-select
                                    v-model="slotForms.forms.comparyId"
                                    collapse-tags
                                    filterable
                                    @change="selectStore"
                                    placeholder="所属企业"
                            >
                                <el-option
                                        v-for="item in allCustomer"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                                prop="forms.storeId"
                                label="所属门店"
                                :rules="[
                {
                  required: true,
                  message: '请选择所属门店',
                  trigger: 'change'
                }
              ]"
                        >
                            <el-select
                                    v-model="slotForms.forms.storeId"
                                    collapse-tags
                                    filterable
                                    placeholder="所属门店"
                            >
                                <el-option
                                        v-for="item in allStoreInfo"
                                        :key="item.storeId"
                                        :label="item.storeName"
                                        :value="item.storeId"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item
                          prop="forms.provinceId"
                          label="所属省"
                          :rules="[
                            {
                              required: true,
                              message: '请选择所属省',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select
                            v-model="slotForms.forms.provinceId"
                            placeholder="所属省"
                            @change="provinceChange"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in provinceList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item
                          prop="forms.cityName"
                          label="所属市"
                          :rules="[
                            {
                              required: true,
                              message: '请选择所属市',
                              trigger: 'blur'
                            }
                          ]"
                        >
                          <el-select
                            v-model="slotForms.forms.cityName"
                            placeholder="所属市"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in cityList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.name"
                            ></el-option>
                          </el-select>
                        </el-form-item> -->
                        <el-form-item
                                prop="forms.freezerType"
                                label="冷柜类型"
                                :rules="[
                {
                  required: true,
                  message: '请选择冷柜类型',
                  trigger: 'change'
                }
              ]"
                        >
                            <dict-select
                                    v-model="slotForms.forms.freezerType"
                                    placeholder="冷柜类型"
                                    :pkey="'freezer_type'"
                            ></dict-select>
                        </el-form-item>
                        <el-form-item label="冷柜厂家" prop="forms.freezerCompany">
                            <el-input
                                    v-model="slotForms.forms.freezerCompany"
                                    placeholder="冷柜厂家"
                                    clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="是否有中央空调" prop="forms.isCentralAir">
                            <el-radio v-model="slotForms.forms.isCentralAir" :label="0"
                            >否
                            </el-radio
                            >
                            <el-radio v-model="slotForms.forms.isCentralAir" :label="1"
                            >是
                            </el-radio
                            >
                        </el-form-item>
                        <el-form-item
                                label="已使用时长"
                                prop="forms.applyTime"
                                :rules="[
                {
                  pattern: /^\d+(\.\d{1,3})?$/,
                  message: '已使用时长不符合规范(非负数最多三位小数)',
                  trigger: ['blur']
                }
              ]"
                        >
                            <el-input
                                    v-model="slotForms.forms.applyTime"
                                    placeholder="已使用时长"
                                    clearable
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="联系人" prop="forms.contactMan">
                            <el-input
                                    v-model="slotForms.forms.contactMan"
                                    placeholder="联系人"
                                    clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                                label="联系电话"
                                prop="forms.contactPhone"
                                :rules="[{ validator: CheckPhone, trigger: 'blur' }]"
                        >
                            <el-input
                                    v-model="slotForms.forms.contactPhone"
                                    placeholder="联系电话"
                                    clearable
                            ></el-input>
                        </el-form-item>

                        <el-form-item
                                label="容积"
                                prop="forms.volume"
                                :rules="[{ validator: validatorIntNum, trigger: 'blur' }]"
                        >
                            <el-input
                                    v-model="slotForms.forms.volume"
                                    placeholder="容积"
                                    clearable
                            ></el-input>
                        </el-form-item>
                        <!--<el-form-item label="地理位置" prop="forms.freezerPosition">-->
                        <!--<el-input-->
                        <!--v-model="slotForms.forms.freezerPosition"-->
                        <!--placeholder="地理位置"-->
                        <!--clearable-->
                        <!--&gt;</el-input>-->
                        <!--</el-form-item>-->

                        <el-form-item label="型号" prop="forms.freezerModel">
                            <el-input
                                    v-model="slotForms.forms.freezerModel"
                                    placeholder="型号"
                                    clearable
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="forms.alarmId" label="温湿度标准">
                            <el-select
                                    v-model="slotForms.forms.alarmId"
                                    filterable
                                    clearable
                                    placeholder="请选择温湿度标准"
                            >
                                <el-option
                                        v-for="item in humitureTree"
                                        :key="item.alarmId"
                                        :label="item.tempAndHumidityStandardName"
                                        :value="item.alarmId"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="监控设备商" prop="forms.monitorDeviceMerchant">
                            <el-input
                                    v-model="slotForms.forms.monitorDeviceMerchant"
                                    placeholder="监控设备商"
                                    clearable
                            ></el-input>
                        </el-form-item>
                    </template>
                    <template slot="submit">保存</template>
                    <template slot="reset">返回</template>
                </e6-form-extend>
            </div>
        </section>
        <!-- content end -->
    </div>
</template>
``
<script>
    import {SaveFreezerInfo, FindFreezerInfoById} from "@/api/base/freezer";
    import resizeListener from "_private/mixins/resizeListener";
    import {
        CheckRemarkLength,
        CheckPriceOrDistance,
        CheckPhone,
        validatorIntNum
    } from "@/utils/validation";
    import {FetchHumitureName} from "@/api/systemSetting/humitureStandardSet";

    import {FetchGetArea} from "@/api/public";
    import {FetchAllCustomer} from "@/api/systemSetting/interfaceUserManager";
    import {FindStoreInfoAll} from "@/api/base/store";

    export default {
        mixins: [resizeListener],
        data() {
            return {
                breadcrumbs: [
                    {
                        path: "/home",
                        isRedirect: true,
                        meta: {
                            title: "首页"
                        }
                    },
                    {
                        path: "/baseFreezerList",
                        isRedirect: true,
                        meta: {
                            title: "冷柜基础信息"
                        }
                    }
                ],
                formExtend: {
                    forms: {
                        freezerName: "",
                        comparyId: "",
                        provinceName: "",
                        cityName: "",
                        applyTime: "",
                        storeId: "",
                        provinceId: "",
                        freezerType: "",
                        freezerCompany: "",
                        isCentralAir: "",
                        contactMan: "",
                        contactPhone: "",
                        volume: "",
                        freezerPosition: "",
                        freezerModel: "",
                        alarmId: "",
                        monitorDeviceMerchant: '',
                    },
                    extends: []
                },
                editState: false,
                provinceList: [],
                cityList: [],
                allCustomer: [],
                allStoreInfo: [],
                storagePurposeLists: [],
                shipmentLists: [],
                CheckRemarkLength: CheckRemarkLength,
                CheckPriceOrDistance: CheckPriceOrDistance,
                CheckPhone: CheckPhone,
                validatorIntNum: validatorIntNum,
                loadingState: false,
                humitureTree: []
            };
        },
        computed: {
            pageType() {
                return this.$route.query.pageType ? this.$route.query.pageType : "1";
            },
            pageTitle() {
                const pageTitle =
                    this.pageType === "1" ? "冷柜基础信息新增" : "冷柜基础信息修改";
                return pageTitle;
            },
            id() {
                return this.$route.query.id;
            },
            provinceId() {
                return this.$route.query.provinceId;
            }
        },
        created() {
            this.FetchHumitureName();
            this.FetchGetArea(0, 1, 1);
            this.initAllCustomer();
            let breadcrumb = {
                path: "/systemSettingDataDictionaryMaintenanceEdit",
                isRedirect: false,
                meta: {
                    title: this.pageTitle
                }
            };
            this.breadcrumbs.push(breadcrumb);
            if (this.pageType !== "1") {
                this.FindFreezerInfoById({freezerId: this.id});
                this.editState = true;
            }
        },
        methods: {
            // 获取温湿度标准下拉Tree
            FetchHumitureName() {
                FetchHumitureName()
                    .then(response => {
                        if (response.result && Array.isArray(response.result)) {
                            this.humitureTree = response.result;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            /**
             *  初始化企业下拉信息
             */
            initAllCustomer() {
                FetchAllCustomer()
                    .then(response => {
                        if (
                            response.result &&
                            response.result &&
                            Array.isArray(response.result)
                        ) {
                            this.allCustomer = response.result;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            initAllStore(comparyId) {
                FindStoreInfoAll({comparyId: comparyId}).then(response => {
                    if (
                        response.result &&
                        response.result &&
                        Array.isArray(response.result)
                    ) {
                        this.allStoreInfo = response.result;
                    }
                });
            },
            // 根据父级获取地区下拉框
            FetchGetArea(parentId, type, num) {
                FetchGetArea(parentId, type)
                    .then(response => {
                        if (response.result && Array.isArray(response.result)) {
                            if (num == 1) {
                                this.provinceList = response.result;
                            } else if (num == 2) {
                                this.cityList = response.result;
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            //企业选择联动门店
            selectStore() {
                this.formExtend.forms.storeId = "";
                this.allStoreInfo = [];
                this.initAllStore(this.formExtend.forms.comparyId);
            },
            //省选择事件
            provinceChange() {
                this.cityList = [];
                this.formExtend.forms.cityName = "";
                this.provinceList.forEach(item => {
                    if (this.formExtend.forms.provinceId == item.id) {
                        this.formExtend.forms.provinceName = item.name;
                        return;
                    }
                });
                this.FetchGetArea(this.formExtend.forms.provinceId, 2, 2);
            },
            // 修改冷柜数据时，先获取冷柜数据信息
            FindFreezerInfoById(response) {
                FindFreezerInfoById(response)
                    .then(response => {
                        if (response.result.comparyId) {
                            Promise.all([this.initAllStore(response.comparyId)]).then(() => {
                                this.formExtend.forms = Object.assign({}, response.result);
                                if (this.provinceId) {
                                    this.formExtend.forms.provinceId = this.provinceId;
                                } else {
                                    this.formExtend.forms.provinceId = "";
                                }
                                this.FetchGetArea(this.provinceId, 2, 2);
                            });
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            // 新增，修改冷柜数据
            SaveFreezerInfo(response) {
                SaveFreezerInfo(response)
                    .then(response => {
                        this.submitCallback(response);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // 新增冷柜信息完成时的回调函数
            submitCallback(response) {
                let type = response.code === 1 ? "success" : "error";
                let message = response.message;
                this.$message({
                    showClose: true,
                    message: message,
                    type: type,
                    duration: 2000,
                    onClose: () => {
                        if (type === "success") {
                            this.$router.push({
                                path: "/baseFreezerList",
                                query: {refreshportion: true}
                            });
                        }
                        this.loadingState = false;
                    }
                });
            },
            // 提交
            handleSubmitForm(e) {
                if (e) {
                    this.loadingState = true;
                    this.SaveFreezerInfo(Object.assign({}, this.formExtend.forms));
                }
            },
            // 取消
            handleResetForm() {
                this.$router.push("/baseFreezerList");
            }
        }
    };
</script>

<style lang="scss" scoped>
    .upload-demo {
        width: 300px;
        margin: 10 150px 10px 200px;
    }

    .page-view {
        height: 100%;
    }

    .title-section {
        padding: 15px 20px 10px;
    }

    .content-section {
        overflow: auto;
    }

    .content-section {
        .form-wrapper {
            padding-top: 20px;
            margin: 0 20px;
            background-color: #fff;
        }
    }

    /deep/ .hide .el-upload--picture-card {
        display: none;
    }

    /deep/ .e6-from--column-2 {
        .el-input {
            width: 300px;
        }
        .el-textarea__inner {
            width: 500px;
        }
    }
</style>
